import { createFileRoute } from "@tanstack/react-router";
import { SmsContactsPage } from "@/features/sms/contacts-page";
import { ensureElementVisible } from "@/lib/route-guards";

export const Route = createFileRoute("/_auth/sms/kontakty")({
	beforeLoad: async ({ context, location }) => {
		await ensureElementVisible(context.queryClient, "sidebar.sms.kontakty", location.pathname);
	},
	component: SmsContactsPage,
});
